module.exports = __webpack_public_path__ + "static/media/lamina19img2.fa7a24b6.png";